import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import KnowledgeAssetTagAppResource from './KnowledgeAssetTagAppResource';
import KnowledgeBaseAppResource from './KnowledgeBaseAppResource';
import KnowledgeAssetCategoryAppResource from "./KnowledgeAssetCategoryAppResource";

export const CTA_LINK_TO_HOME_SERVICES = 'link-to-home-services';
export const CTA_LINK_TO_URL = 'link-to-url';

export const CTA_TYPES = {
    CTA_LINK_TO_HOME_SERVICES,
    CTA_LINK_TO_URL,
};

class KnowledgeAssetArticleAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Knowledge-Asset-Article';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'knowledge/assets/articles';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'publishDate',
            'title',
            'isPublished',
            'meta',
            'knowledgeBaseUuid',
            'coverFileUuid',
            'overview',
            'articleMainBody',
            'disclaimer',
            'ctaEnabled',
            'ctaDetails',
            'knowledgeBase',
            'tags',
            'categories',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            knowledgeBase: KnowledgeBaseAppResource,
            tags: KnowledgeAssetTagAppResource,
            categories: KnowledgeAssetCategoryAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            knowledgeBase: 'knowledge_base_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            publishDate: {
                presence: true,
                datetime: true,
            },
            title: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 2,
                    maximum: 255,
                },
            },
            isPublished: {
                type: 'boolean',
            },
            meta: {},
            knowledgeBaseUuid: {
                type: 'string',
                presence: true,
            },
            coverFileUuid: {
                type: 'string',
            },
            overview: {
                type: 'string',
            },
            articleMainBody: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                },
            },
            disclaimer: {
                type: 'string',
            },
            ctaEnabled: {
                type: 'boolean',
            },
            ctaDetails: {},
            tags: {
                type: 'array'
            },
            categories: {
                type: 'array'
            },
        };
    }
}

export default KnowledgeAssetArticleAppResource;
